export class AdminPermanentContactsController {
  constructor($scope, UserService, toastr, RegionService, socket) {
    $scope.vm = this;
    this.UserService = UserService;
    this.RegionService = RegionService;
    this.scope = $scope;
    this.toastr = toastr;
    this.socket = socket;

    this.scope.messagingFilters = {};
    this.scope.showView = {
      read: true,
      create: false,
      edit: false,
      message: false
    };
    this.scope.allContacts = [];

    this.init();
  }

  init() {

    this.scope.ages = [
      {id: '1', value: "From 18 to 24"},
      {id: '2', value: "From 25 to 31"},
      {id: '3', value: "From 32 to 38"},
      {id: '4', value: "From 39 to 45"},
      {id: '5', value: "From 46 to 52"},
      {id: '6', value: "From 53 to 100"}
    ];

    this.scope.getFullFilterAge = (age) => {
      switch(age) {
        case '1':
          return {minage: 18, maxage: 24}
        case '2':
          return {minage: 25, maxage: 31}
        case '3':
          return {minage: 32, maxage: 38}
        case '4':
          return {minage: 39, maxage: 45}
        case '5':
          return {minage: 46, maxage: 52}
        case '6':
          return {minage: 53, maxage: 100}
        default:
          return {minage: 18, maxage: 100}
      }
    }

    this.RegionService.getRegionsList()
      .then((response) => { let regions = response.data;
        this.scope.regions = regions.data;
      })
      .catch((response) => { let error = response.data;
        console.log("Can`t get regions from database");
      });

    this.getContacts = () => {
      this.UserService.getPermanentContacts()
        .then((response) => { let data = response.data;
          //console.log(data);
          this.scope.allContacts = data.data;
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        })
    };

    this.getContacts();

    this.scope.changeView = (view) => {
      _.forEach(this.scope.showView, (item, index) => {
        this.scope.showView[index] = index == view;
      })
    };

    this.scope.createContact = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if(this.scope.errors.length) {
        return false;
      }

      this.UserService.createContact(this.scope.contactFormModel)
        .then((response) => { let data = response.data;
          //console.log(data);
          this.getContacts();
          this.scope.changeView('read');
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        })
    };

    this.scope.editContactLink = (contact) => {
      this.scope.contactFormModel = angular.copy(contact);
      this.scope.changeView('edit');
    };

    this.scope.editContact = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if(this.scope.errors.length) {
        return false;
      }

      this.UserService.updateUser(this.scope.contactFormModel)
        .then((response) => { let data = response.data;
          //console.log(data);
          this.getContacts();
          this.scope.changeView('read');
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        })
    };

    this.scope.removeContact = (contact) => {
      this.UserService.removeUser(contact)
        .then((response) => { let data = response.data;
          //console.log(data);
          this.getContacts();
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        })
    };

    this.scope.createContactLink = () => {
      this.scope.errors = [];
      this.scope.contactFormModel = {
        username: '',
        email: '',
        password: '',
        usertype: +'1',
        status: 1,
        gender: 1,
        birthday: new Date(1994, 7, 31, 0, 0, 0, 0),
        age: 99,
        permanent: true
      };
      this.scope.changeView('create');
    };

    this.scope.sendMessageToUsers = (contact) => {
      this.scope.errors = [];
      this.scope.messageFormModel = {
        canReply: false,
        message: ''
      };
      this.scope.contactFormModel = angular.copy(contact);
      this.scope.changeView('message');
    };

    this.scope.sendMessage = (form) => {

      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if (key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if (keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if (this.scope.errors.length) {
        return false;
      }

      if (confirm('Are you sure to want to send these messages')) {

        let filter = {};

        if (this.scope.messagingFilters && this.scope.messagingFilters.region) {
          filter['region'] = this.scope.messagingFilters.region;
        }
        if (this.scope.messagingFilters && this.scope.messagingFilters.age) {
          let age = this.scope.getFullFilterAge(this.scope.messagingFilters.age)

          if (age && age.minage && age.maxage) {
            // Sent straight to User.list() on the server, which paginates and counts
            // via countDocuments() - and countDocuments() rejects $where with
            // "$where is not allowed in this context". Express the same age window
            // as a birthday range, which is a plain indexable query.
            let now = new Date();
            filter['birthday'] = {
              $gte: new Date(now.getFullYear() - age.maxage - 1, now.getMonth(), now.getDate() + 1).toISOString(),
              $lte: new Date(now.getFullYear() - age.minage, now.getMonth(), now.getDate()).toISOString()
            };
          }
        }
        if (this.scope.messagingFilters && this.scope.messagingFilters.gender) {
          filter['gender'] = this.scope.messagingFilters.gender;
        }


        filter['status'] = 1;
        filter['permanent'] = false;
        filter['_id'] = {$ne: this.scope.contactFormModel._id};

        this.socket.emit('messageFromContacts', JSON.stringify({
          sender: this.scope.contactFormModel._id,
          filter: filter,
          msg: this.scope.messageFormModel.message,
          canReply: this.scope.messageFormModel.canReply
        }));

        this.toastr.info('Messages sent');
        this.scope.messageFormModel.message = '';
      }
    }
  }
}
